export default __webpack_public_path__ + "static/media/mortgage-external.f39156e5.svg";